import request from '@/plugin/axios'

export function SignupMember (data) {
  return request({
    url: '/study-team/signup',
    method: 'post',
    data
  })
}

export function ListMembers (data) {
  return request({
    url: '/study-team/index',
    method: 'get',
    params: data
  })
}

export function ListUsers (data) {
  return request({
    url: '/study-team/list-users',
    method: 'get',
    params: data
  })
}

export function GetAssistItems (id) {
  return request({
    url: '/study-team/assist-items?id=' + id,
    method: 'get'
  })
}

export function ViewMember (id) {
  return request({
    url: '/study-team/view?id=' + id,
    method: 'get'
  })
}

export function AddMember (data) {
  return request({
    url: '/study-team/add',
    method: 'post',
    data
  })
}

export function InviteMember (data) {
  return request({
    url: '/study-team/invite',
    method: 'post',
    data
  })
}

export function DeleteMember (id) {
  return request({
    url: '/study-team/delete?id=' + id,
    method: 'delete'
  })
}

export function GetInvite (token) {
  return request({
    url: '/study-team/check-token?token=' + token,
    method: 'get'
  })
}

export function UpdateMember (data) {
  return request({
    url: '/study-team/update?id=' + data.id,
    method: 'post',
    data
  })
}
